import { AppType } from 'src/lib/fliko/enums/appName';
import { ConciergeType } from 'src/lib/fliko/models/concierge/concierge.data';
import { DefectData } from 'src/lib/fliko/models/defects/defect.data';
import { IssueBase, IssueMessage, IssueType } from 'src/lib/fliko/models/defects/issue.base';
import { IssueData } from 'src/lib/fliko/models/defects/issue.data';
import { DefectType } from 'src/lib/fliko/models/defects/defect-settings.data';
import { ResidentData } from 'src/lib/fliko/models/person/resident.data';
import { Language } from 'src/lib/fliko/models/translation/generic';
import { RentalUnit, RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { CreateServiceUser } from 'src/lib/fliko/models/users/createdUser.data';
import { ServiceUserData, UserBase, UserData } from 'src/lib/fliko/models/users/user.data';
import { EditedImageVM } from 'src/app/shared/models/editem-image.view-model';
import { FileInStorageVM } from 'src/app/shared/models/file.data';
import { SubcontractorVM } from 'src/app/view/estate-view/services/models/subcontractor.view.model';

export type IssueUserData = UserData | ServiceUserData;
export type IssueBaseVM = _IssueBaseVM<IssueBase, IssueUserData>;

// TODO @michal-fliko zdecyduj proszę, czy ten nieużywany typ U jest tu potrzebny, to twoja zmiana była ;)
export interface _IssueBaseVM<T, U extends IssueUserData = UserData> {
  data: T;
  /**
   * @defect - object | undefined
   * @issue - IssueType.ISSUE (always)
   */
  type: DefectType | IssueType | ConciergeType | undefined;
  dataType: IssueType;
  typeName: string;
  app: AppType;
  appName: string;

  /** Issue title in app's current language */
  title: string;
  /** reporter in defects, subject in resident issues */
  user: UserBase | undefined;
  /** reporter in defects, subject in resident issues */
  resident: ResidentData | undefined;
  /** issues and CMR defects; in pre 1.5.6 defects duplicates user */
  admin: UserData | undefined;
  /** estate admin assigned to issue */
  assignedUser: UserData | undefined;
  /** service defects only*/
  repSubcontractor: SubcontractorVM | undefined;

  images: EditedImageVM[];
  attachments: FileInStorageVM[];

  updated: boolean;
}

export interface IssueDetailsVM {
  id: string;
  updated: boolean;
}

export interface IssueVM extends _IssueBaseVM<IssueData> {
  type: IssueType.ISSUE;
  repSubcontractor: undefined;

  // TODO: remove, when res-issues implemented on mobile
  updated: false;
}

export interface DefectVM extends _IssueBaseVM<DefectData, IssueUserData> {
  type: DefectType | undefined;

  location: DefectLocationVM;
  locationType: DefectLocationType;

  unit: RentalUnit | undefined;
  servicer: ServiceUserData | CreateServiceUser | undefined;

  servSubcontractor: SubcontractorVM | undefined;
  webconId: number | undefined;
}

export interface DefectResidentVM {
  userId: string;
  residentId: string | null;
  phone: string | null;
}

export interface DefectLocationVM {
  block: string | null;
  staircase: string | null;
  floor: string | null;
  number: string | null;
  typeHR: string;
}

export namespace DefectLocationVM {
  /** Special value used to indicate, that defect belongs to all blocks / staircases / floors */
  export const ALL = 'all';
}

export interface DefectMessageVM extends IssueMessage {
  propertyManager: boolean;
  myself: boolean;
  storageImages: FileInStorageVM[];
  language?: Language;
  translation?: string;
}

export interface DefectConversationVM {
  reporter: DefectMessageVM[];
  servicer: DefectMessageVM[];
}

export enum DefectLocationCommon {
  BUILDING = 'building',
  OUTDOOR = 'outdoor'
}

export type DefectLocationType = DefectLocationCommon | RentalUnitType;

export namespace DefectLocationType {
  export function fromDefect(defect: DefectData): DefectLocationType {
    if (defect.locationUnitId && defect.locationUnitType) {
      return defect.locationUnitType;
    } else {
      return defect.locationInside ? DefectLocationCommon.BUILDING : DefectLocationCommon.OUTDOOR;
    }
  }
}

/** reflect $priority-color in colors.scss */
export type IssuePriorityColor = 'issuePr-low' | 'issuePr-mid' | 'issuePr-high';

/** reflect $status-color in colors.scss */
export type IssueStatusColor =
  | 'issueSt-noticed'
  | 'issueSt-in_progress'
  | 'issueSt-fixed'
  | 'issueSt-cancelled'
  | 'issueSt-accepted'
  | 'issueSt-none';
